import React from 'react';
import { Router, Route, Switch, Redirect, BrowserRouter } from 'react-router-dom';
import routers from './routers';
import history from './utils/history';

const getRoute = () => {
    let ary: any[] = [];
    routers.forEach((route) => {
        ary.push(
            <Route
                exact={route.exact}
                key={route.name}
                path={route.path}
                render={(props: any) => {
                    return <route.component {...props} {...(window as any).INIT_STATE} />;
                }}
            />
        );
    });
    ary.push(
        <Route key="404" path="*">
            <Redirect to="/404" />
        </Route>
    );
    return ary;
};

const App: React.FC = () => {
    return (
        <div className="App">
            <BrowserRouter>
                <Switch>{getRoute()}</Switch>
            </BrowserRouter>
        </div>
    );
};

export default App;
